export { default as ColorSwatchSolidIcon } from './ColorSwatchSolidIcon';
